import React, { useState, useEffect } from "react"
import Modal from "react-bootstrap/Modal"
import Tabs from "@mui/material/Tabs"
import Tab from "@mui/material/Tab"
import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import Row from "react-bootstrap/esm/Row"
import Col from "react-bootstrap/esm/Col"
import PatientDetails from "./CreateDischargeSummary"
import PreviousSummary from "./AllSummary"
import "./dischargeSummary.scss"
import PermissionUtils from "../../../../core/store/utils/PermissionUtils"
import { useSelector } from "react-redux"
import { getChemoOrderByAppointment, getMedicalRecordByAppointmentId } from "core/services/api"
import { getVitals } from "core/services/api/patientDiagnosisService"
import PrintDischargeSummary from "./PrintDischargeSummary"
import { MocUserRole } from "core/services/models/Enums"
import PrintDetailedDischargeSummary from "./PrintDetailedDischargeSummary"
import { calculateAge } from "core/utils/date"

interface TabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
}
function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  )
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  }
}

function DischargeSummary({ closePrintModal, patientMOC, appointmentId, appointmentDetails, smartSummaryDetails }: any) {
  const userRole = useSelector((state: any) => state?.user?.role)
  const [readOnly, setReadOnly] = useState<boolean>(false)

  useEffect(() => {
    //Discharge summary to be enabled for front desk, RMO, Consultant, nurse
    const isReadOnly =
      ((userRole === MocUserRole.RMO ||
        userRole === MocUserRole.CONSULTANT) ||
        userRole === MocUserRole.FRONT_DESK ||
        userRole === MocUserRole.NURSE) &&
        appointmentDetails?.isEditable &&
        appointmentDetails?.arrivalTime
        ? false
        : true
    setReadOnly(isReadOnly)
  }, [appointmentDetails])

  const [vitalsData, setVitalsData] = useState<any>({})
  const [smartSummaryData, setSmartSummaryData] = useState<any>()
  const [chemoData, setChemoData] = useState<any>()
  const [show, setShow] = useState(true)
  const [previewShow, setPreviewShow] = useState<boolean>(false)
  const [appointmentDischargeId, setAppointmentDischargeId] = useState<any>()
  const handleClose = () => {
    setShow(false)
    closePrintModal(false)
  }

  const handlePreviewShow = (bool: any) => {
    setPreviewShow(bool)
    setValue(2)
  }

  const [value, setValue] = React.useState(0)

  useEffect(() => {
    if (appointmentId) {
      getMedicalRecordByAppointmentId(appointmentId)
        .then((response: any) => {
          const recordId = response?.id
          setAppointmentDischargeId(response?.appointmentId)
          if (recordId) {
            getVitals(recordId, true)
              .then((data: any) => {
                const res = data.data
                setVitalsData(res)
              })
              .catch((err: any) => {
                console.log(err)
              })
          }
        })
        .catch((err: any) => {
          console.log("error in fetching record", err)
        })

      getChemoOrderByAppointment(appointmentId)
        .then((response: any) => {
          setChemoData(response)
        })
        .catch((err: any) => {
          console.log("error in fetching record", err)
        })

    }
  }, [])

  useEffect(() => {
    if (smartSummaryDetails) {
      setSmartSummaryData(smartSummaryDetails)
    }
  }, [smartSummaryDetails])

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    if (newValue !== 2) {
      setValue(newValue)
      setPreviewShow(false)
    } else {
      setValue(newValue)
    }
  }

  console.log("chemoData", chemoData)

  return (
    <div>
      <Modal className="modal-chemo" size="xl" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            <Row>
              <Col className="basic-patient-details">
                {PermissionUtils.displayPatientName(
                  userRole,
                  patientMOC,
                  false,
                  null,
                  "-"
                )}
                {patientMOC?.mocId}-{patientMOC?.gender}-{calculateAge(patientMOC?.dob)}
              </Col>
            </Row>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className="heading-test" style={{ paddingLeft: "25px" }}>
            Discharge Summary
          </Row>
          <Box sx={{ width: "100%", marginTop: "20px" }}>
            <Box sx={{}}>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
                TabIndicatorProps={{
                  sx: {
                    bgcolor: "blue",
                    height: "2px",
                    color: "blue",
                  },
                }}
                sx={{
                  "& button:active": {
                    color: "blue",
                  },
                  "& button:selected": {
                    color: "blue",
                  },
                }}
              >
                <Tab
                  sx={{
                    textTransform: "none",
                    fontSize: "20px",
                    fontWeight: "700",
                  }}
                  label="Patient Details"
                  {...a11yProps(0)}
                />
                <Tab
                  sx={{
                    textTransform: "none",
                    fontSize: "20px",
                    fontWeight: "700",
                  }}
                  label="Previous Summaries"
                  {...a11yProps(1)}
                />
                {
                  previewShow && (
                    <Tab
                      sx={{
                        textTransform: "none",
                        fontSize: "20px",
                        fontWeight: "700",
                      }}
                      label="Preview Discharge Summary"
                      {...a11yProps(1)}
                    />
                  )
                }
              </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
              <PatientDetails
                patientInfo={patientMOC}
                appointmentId={appointmentId}
                readOnly={readOnly}
                vitalsData={vitalsData}
                smartSummaryData={smartSummaryData}
                handlePreviewShow={handlePreviewShow}
              />
            </TabPanel>
            <TabPanel value={value} index={1}>
              <PreviousSummary
                patientInfo={patientMOC}
                smartSummaryDetails={smartSummaryDetails}
              />
            </TabPanel>
            {
              previewShow && (
                <TabPanel value={value} index={2}>
                  {chemoData?.viewType === "DETAILED" ? (
                    <PrintDetailedDischargeSummary
                      patient={patientMOC}
                      vitalsData={vitalsData}
                      smartSummaryData={smartSummaryData}
                      chemoData={chemoData}
                      appointmentDischargeId={appointmentDischargeId}
                      appointmentDate={appointmentDetails?.scheduleDate}
                    />
                  ) : (
                    <PrintDischargeSummary
                      patient={patientMOC}
                      vitalsData={vitalsData}
                      smartSummaryData={smartSummaryData}
                      chemoData={chemoData}
                      appointmentDate={appointmentDetails?.scheduleDate}
                    />
                  )}
                </TabPanel>
              )
            }
          </Box>
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default DischargeSummary